import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

export class Icon extends PureComponent {
  iconBuilder() {
    let icon = `${midas.icon} ${midas[this.props.typeName]}`

    if (this.props.large) {
      icon += ` ${midas.largeIcon}}`
    }
    return icon
  }

  render() {
    return <i className={`${this.props.additionalClassNames} ${this.iconBuilder()}`} style={this.props.style} />
  }
}

Icon.defaultProps = {
  large: false,
  style: null,
  additionalClassNames: '',
}

Icon.propTypes = {
  typeName: PropTypes.string.isRequired,
  large: PropTypes.bool,
  style: PropTypes.any,
  additionalClassNames: PropTypes.string,
}
